export default {
  common: {
    account: '계정',
    myPage: '마이페이지',
    booking: '예약 내역',
    logout: '로그아웃',
    save: '저장',
    colon: ': ',
    multiply: '×',
    next: '다음',
    return: '돌아가기',
    toPay: '결제하기',
    update: '수정',
    search: '검색',
    space: ' ',
    add: '추가',
    confirm: '확인',
    cancel: '취소',
    searchPlaceholder: '검색...',
    tilde: '~',
    showMore: '더 보기'
  },
  price: {
    primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
    jpyWord: 'JPY',
    jpySymbol: '¥'
  },
  footer: {
    terms: '이용약관',
    cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
    copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.'
  },
  validation: {
    required: '{{field}}는 필수 입력 항목입니다.',
    invalid: '유효한 {{field}}을 입력해주세요.',
    password:
      '대문자, 소문자, 특수문자, 숫자를 포함한 8자 이상의 비밀번호를 입력해주세요.',
    imageType: '이미지 파일을 선택해주세요.',
    fileSize: '{{size}}MB 이하의 파일을 선택해주세요.',
    range: '{{field}}는 {{min}}에서 {{max}} 사이의 값을 입력해주세요.',
    requiredSelect: '{{field}}을 선택해주세요.',
    emailNotMatch: '이메일 주소가 일치하지 않습니다.',
    emailAlreadyRegistered:
      '해당 이메일 주소는 이미 등록되어 있습니다. 로그인 버튼을 통해 로그인해주세요.'
  },
  firebase: {
    'auth/wrong-password': '아이디 또는 비밀번호가 정확하지 않습니다.',
    'auth/user-not-found': '아이디 또는 비밀번호가 정확하지 않습니다.',
    'auth/email-already-in-use':
      '입력하신 이메일 주소는 이미 등록되어 있습니다.',
    'auth/too-many-requests':
      '로그인에 실패하였습니다. 잠시 후에 다시 시도하거나 비밀번호를 재설정 하여주시기 바랍니다.'
  },
  apiErrors: {
    baseError: '에러가 발생했습니다.',
    clientError: '요청에 오류가 발생했습니다.',
    serverError: '서버 요청에 실패하였습니다.',
    connectionError:
      '접속 에러가 발생했습니다. 통신 환경을 다시 한 번 확인하여 주시기 바랍니다.',
    requestError: '요청에 오류가 발생했습니다.',
    ARSError: {
      AFFILIATE_ID_REQUIRED:
        '작동 에러. 회원 한정 페이지에서부터 다시 접속으로 부탁드립니다.',
      BOOKING_NOT_ENOUGH_ALLOTMENT:
        '선택하신 날짜/시간은 현재 만석입니다. 다른 날짜/시간으로 다시 예약을 시도해 주시기 바랍니다.',
      BOOKING_NO_AVAILABILITY:
        '선택하신 날짜/시간은 현재 만석입니다. 다른 날짜/시간으로 다시 예약을 시도해 주시기 바랍니다.',
      PERMISSION_DENIED: '리소스 액세스 권한이 없습니다.',
      NOT_FOUND: '리소스를 찾을 수가 없습니다.',
      BOOKING_ALREADY_ISSUED: '티켓 발권/교환 후, 취소는 불가합니다.',
      BOOKING_RESERVATION_OVERLIMIT: '예약 가능 수를 초과하였습니다.'
    }
  },
  login: {
    title: '로그인／회원가입',
    caption: '로그인, 회원 가입 방법을 선택하여 주시기 바랍니다.',
    appleLogin: 'Apple',
    googleLogin: 'Google',
    email: '이메일 주소',
    emailConfirm: '이메일 주소(확인)',
    password: '비밀번호',
    button: '로그인',
    forgotPassword: '비밀번호를 잊으셨나요?',
    newAccount: '회원가입',
    signInAgree: `*타사 계정을 이용하여 간편 회원 가입 및 로그인을 하실 수 있습니다. \n *이메일 계정, 타사 계정을 이용하여 회원 가입하시는 경우는 <TermsLink>{{terms}}</TermsLink> 및 <PrivacyLink>{{privacy}}</PrivacyLink> 에 동의한 것으로 간주됩니다.`
  },
  password: {
    changePassword: '비밀번호 변경',
    resetPassword: '비밀번호 재설정',
    sendResetEmail: '비밀번호 재설정 메일을 발송하기',
    sendResetEmailSuccess:
      '비밀번호 재설정 URL이 {{email}}으로 발송되었습니다. 확인하고 비밀번호 재설정을 진행하여 주시기 바랍니다.',
    oldPassword: '이전 비밀번호',
    newPassword: '새로운 비밀번호',
    changePasswordSuccess: '비밀번호를 변경하였습니다.'
  },
  date: {
    sunday: '일요일',
    monday: '월요일',
    tuesday: '화요일',
    wednesday: '수요일',
    thursday: '목요일',
    friday: '금요일',
    saturday: '토요일'
  },
  profile: {
    title: '개인정보',
    firstName: '이름(반각 영문자만 입력해주세요)',
    lastName: '성(반각 영문자만 입력해주세요)',
    email: '이메일',
    confirmEmail: '이메일(확인)',
    password: '비밀번호',
    gender: '성별',
    birthday: '생년월일',
    country: '국가',
    prefecture: '도도부호',
    genderOptions: {
      male: '남성',
      female: '여성',
      other: '기타'
    },
    updateProfileSuccess: '개인정보를 성공적으로 업데이트했습니다.',
    updateProfileFailed:
      '개인정보 업데이트에 실패하였습니다. 나중에 다시 시도해주세요.'
  },
  weeks: {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土'
  },
  empty: {
    message: '콘텐츠를 찾을 수 없습니다.'
  }
};
